import { render, staticRenderFns } from "./asideDocument.vue?vue&type=template&id=2ca22110&scoped=true&"
import script from "./asideDocument.vue?vue&type=script&lang=js&"
export * from "./asideDocument.vue?vue&type=script&lang=js&"
import style0 from "./asideDocument.vue?vue&type=style&index=0&id=2ca22110&prod&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2ca22110",
  null
  
)

export default component.exports